// extracted by mini-css-extract-plugin
export default {"narrativeCell":"NarrativeCell_narrativeCell__vNs7J","max":"NarrativeCell_max__36mEf"};